import React from 'react';

import PropTypes from 'prop-types';

import Pagination from '@mui/material/Pagination';

import useTracking from 'components/Globals/Analytics';
import { SECTIONS } from 'components/Globals/Analytics/constants';

import usePageContext from 'utils/hooks/usePageContext';

import { makeStyles } from 'src/makeStyles';

import { PAGINATION_VARIANTS } from '../constants/consts';
import { colors } from '../constants/styleConstants';

const useStyles = makeStyles()((theme, { variant }) => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    width: '100%',
    '& .MuiPaginationItem-textPrimary.Mui-selected': {
      background: 'transparent',
      border: variant === PAGINATION_VARIANTS.PRIMARY ? `2px solid ${colors.blue3}` : `2px solid ${colors.primary}`,
      color: colors.textColor,
    },
  },
}));

const FbPagination = ({ variant, filters, fetchFunction, onPageChange, renderItem }) => {
  const { classes } = useStyles({ variant });
  const { navigate } = usePageContext();
  const count = Math.ceil(filters.total / filters.limit);
  const isAHrefBasedPaginationControls = typeof renderItem !== 'undefined';
  const track = useTracking();

  const handleChange = (event, value) => {
    fetchFunction({ limit: filters.limit, page: value });
    onPageChange();
    navigate.scrollTo();
    track.click({ section: SECTIONS.PAGINATION, meta: { page: value || 1 } });
  };

  const isEmpty = !filters.total;

  if (isEmpty) {
    return null;
  }

  return (
    <div className={classes.root}>
      <Pagination
        count={count}
        page={filters.page}
        color="primary"
        showFirstButton
        showLastButton
        {...(!isAHrefBasedPaginationControls && { onChange: handleChange })}
        {...(isAHrefBasedPaginationControls && { renderItem })}
      />
    </div>
  );
};

FbPagination.propTypes = {
  variant: PropTypes.string,
  fetchFunction: PropTypes.func,
  onPageChange: PropTypes.func,
  filters: PropTypes.shape({
    limit: PropTypes.number,
    page: PropTypes.number,
    total: PropTypes.number,
  }),
};

FbPagination.defaultProps = {
  variant: PAGINATION_VARIANTS.SECONDARY,
  fetchFunction: () => {},
  onPageChange: () => {},
  filters: {
    limit: 20,
    page: 1,
    total: 0,
  },
};

export default FbPagination;
